// src/utils/StatsigClient.js
import { StatsigClient, LogLevel } from '@statsig/js-client';
import { v4 as uuidv4 } from 'uuid';

// eslint-disable-next-line import/no-mutable-exports
export let client = null;

function getOrCreateUserID() {
  const key = 'statsig_user_id';
  let id = localStorage.getItem(key);
  if (!id) {
    id = uuidv4();
    localStorage.setItem(key, id);
  }
  return id;
}

export async function initStatsig(onUpdate) {
  if (typeof window === 'undefined') {
    return;
  }
  if (client) {
    return;
  }

  const userID = getOrCreateUserID();

  client = new StatsigClient(
    process.env.GATSBY_STATSIG_SDK_KEY,
    { userID },
    { logLevel: LogLevel.Debug },
  );

  if (onUpdate) {
    client.on('values_updated', () => {
      onUpdate();
    });
  }

  try {
    await client.initializeAsync();
  } catch (err) {
    console.error('[StatsigClient] initializeAsync() failed', err);
  }
}
